export const updateObject = (oldObjects, updatedProperties) => ({
	...oldObjects,
	...updatedProperties,
})